import * as yup from "yup";

const PAN_REGEX = { pattern: /^[A-Z]{5}[0-9]{4}[A-Z]$/, msg: "Enter a valid PAN (e.g. ABCDE1234F)" };
const GST_REGEX = { pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/, msg: "Enter a valid 15-character GSTIN" };
const IFSC_REGEX = { pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/, msg: "Enter a valid IFSC code (e.g. HDFC0001234)" };
const ACCOUNT_NUMBER_REGEX = { pattern: /^[0-9]{6,20}$/, msg: "Account number must be 6-20 digits, numbers only" };

export const kycSetupSchema = yup.object({
    full_name             : yup.string().trim().required("Full name is required"),
    pan                   : yup.string().trim().uppercase().required("PAN is required").matches(PAN_REGEX.pattern, PAN_REGEX.msg),
    gst                   : yup.string().trim().uppercase().test("gst-format", GST_REGEX.msg, (value) => !value || GST_REGEX.pattern.test(value)),
    account_number        : yup.string().trim().required("Account number is required").matches(ACCOUNT_NUMBER_REGEX.pattern, ACCOUNT_NUMBER_REGEX.msg),
    account_number_confirm: yup.string().trim().required("Please confirm the account number").oneOf([yup.ref("account_number")], "Account numbers do not match"),
    ifsc                  : yup.string().trim().uppercase().required("IFSC code is required").matches(IFSC_REGEX.pattern, IFSC_REGEX.msg),
    account_holder        : yup.string().trim().required("Account holder name is required")
});

export const kycSetupDefaults = {
    full_name             : "",
    pan                   : "",
    gst                   : "",
    account_number        : "",
    account_number_confirm: "",
    ifsc                  : "",
    account_holder        : ""
};
